<template>
  <v-form
    ref="form"
    v-model="valid"
    @submit.prevent="onSubmit"
  >
    <v-card
      height="100%"
      flat
    >
      <v-card-title>
        <slot name="form-title">
          <span class="font-weight-semibold text-base text--primary">{{ $t("Quotation manuelle des manuscrits aux évaluateurs") }}</span>
          <v-spacer />
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="$emit('update:is-form-active',false)"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </slot>
      </v-card-title>

      <v-card-text
        class="overflow-y-auto"
        style="max-height: 500px;"
      >
        <v-row class="pt-5">
          <v-col cols="12">
            <a
              target="_blank"
              href="https://stagingbackend.lysbleueditions.com/speciment_manuscript_orus.xlsx"
            >{{ $t("Télécharger un fichier d'exemple") }}</a>
          </v-col>
          <v-col
            v-if="items.length > 0"
            style="max-height: 400px;overflow-y: auto"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Manuscrit
                    </th>
                    <th class="text-left">
                      Assistant
                    </th>
                    <th class="text-left">
                      STATUS
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(m, i) in items"
                    :key="i"
                  >
                    <td>{{ m.id }}</td>
                    <td>{{ m.code }}</td>
                    <td>
                      <v-chip
                        small
                        dark
                        style="background: red"
                        text-color="white"
                      >
                        {{ m.status }}
                      </v-chip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col
            v-else
            cols="12"
          >
            <!--            <span>{{ $t("Photo") }}</span>-->
            <file-upload
              v-model="file"
              add-class="mx-auto justify-center"
              :label="$t('Upload new file')"
              folder="/manuscripts/csv/"
              :btn="true"
              :extra="false"
              :hide-label="false"
              icon-name="mdi-upload"
              :icon="false"
              :show-download="false"
              inputname="file"
              :crop="false"
              :aspect-ratio="1"
              url="/upload_manuscript"
              accept="*.csv"
              :multiple="false"
              style="width: 100%"
              :event="eventHandler"
            >
              <template #input>
                <v-avatar
                  :color="'primary'"
                  :class="'v-avatar-light-bg primary--text'"
                  :width="450"
                  :height="250"
                  rounded
                  class="mb-4"
                >
                  <div>
                    <p
                      class="font-weight-semibold text-lg "
                    >
                      {{ $t("Déposer le fichier ici") }}
                    </p>
                    <p
                      class="font-weight-semibold text-lg "
                    >
                      {{ $t("Ou") }}
                    </p>
                    <p
                      class="font-weight-semibold text-lg "
                    >
                      {{ $t("Cliquez pour sélectionner le fichier") }}
                    </p>
                  </div>
                  <v-icon
                    size="20"
                    color="primary"
                    style="position: absolute;bottom: 10px; left: 10px"
                  >
                    {{ icons.mdiCloudUploadOutline }}
                  </v-icon>
                </v-avatar>
              </template>
            </file-upload>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <slot name="form-actions">
          <slot name="form-cancel">
            <!--            <v-btn
              :loading="loading"
              color="secondary"
              outlined
              type="reset"
              @click="$emit('is-form-active',false)"
            >
              {{ $t('Annuler') }}
            </v-btn>-->
          </slot>
          <!--          <v-spacer />
          <v-btn
            :loading="loading"
            color="primary"
            class="me-3"
            type="submit"
          >
            {{ $t("Enregistrer") }}
          </v-btn>-->
        </slot>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mdiClose, mdiPencilOutline, mdiPencilOffOutline } from '@mdi/js'
import { computed, ref, watch } from '@vue/composition-api'
import { required, emailValidator } from '@core/utils/validation'
import store from '@/store'
import controller from './Controller'
import FileUpload from '@/components/file_upload'

export default {
  components: { FileUpload },
  model: {
    prop: 'object',
    event: 'update:is-form-active',
  },
  props: {
    object: {
      type: Object,
      default: () => {},
    },
    isFormActive: {
      type: Boolean,
    },
    withPassword: {
      type: Boolean,
      default: true,
    },
    roleOptions: {
      type: Array,
      default: () => [],
    },
    planOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const {
      form,
      isSnackbarBottomVisible,
      snackBarMessage,
    } = controller()
    const errorMessages = ref({ })
    const valid = ref(false)
    const file = ref(false)
    const loading = ref(false)
    const items = ref([])
    const isLoadingIsbns = ref(false)
    const validate = () => {
      form.value.validate()
    }

    const item = computed({
      get: () => props.object,
      set: value => emit('update:object', value),
    })
    const formActive = computed({
      get: () => props.isFormActive,
      set: value => emit('is-form-active', value),
    })

    // const item = ref(JSON.parse(JSON.stringify(blankItem)))
    const resetItem = () => {
      // item.value = {}

      // emit('update:object', item.value)
    }
    const eventHandler = (e, data) => {
      if (e === 'upload') {
        isSnackbarBottomVisible.value = true
        snackBarMessage.value = data.data.message
        emit('refetch-data')
        if (data.data && data.data.length > 0) {
          items.value = data.data
        }
      }
    }
    const onSubmit = () => {
      if (valid.value) {
        loading.value = true
        store.dispatch('manuscript/quote', item.value)
          .then(response => {
            loading.value = false
            if (response.data.error || response.data.errors || (response.data.status && response.data.status === 'false')) {
              if (response.data.errors) {
                // this.toast(this.$t('These credentials do not match our records'), this.$vuetify.theme.currentTheme.error)
                errorMessages.value = { ...response.data.errors }
              } else {
                isSnackbarBottomVisible.value = true
                snackBarMessage.value = response.data.message

                // this.toast(response.data.message, this.$vuetify.theme.currentTheme.error)
              }

              return false
            }
            resetItem()

            // emit('update:is-form-active', false)

            emit('refetch-data')
          }).catch(error => {
            loading.value = false
            console.log('error', error)
            if (error.data.errors) {
            // this.toast(this.$t('These credentials do not match our records'), this.$vuetify.theme.currentTheme.error)
              errorMessages.value = { ...error.data.errors }
            }
          })
      } else {
        validate()
      }
    }
    // eslint-disable-next-line no-unused-vars
    watch(() => props.isFormActive, (newValue, prevValue) => {
      items.value = []
    })
    // eslint-disable-next-line no-unused-vars
    /* watch(() => item, (newValue, prevValue) => {
      console.log('item change', newValue.value)
      emit('input', newValue.value)
    }, { deep: true }) */

    return {
      resetItem,
      form,
      formActive,
      isLoadingIsbns,
      isSnackbarBottomVisible,
      snackBarMessage,
      errorMessages,
      onSubmit,
      item,
      valid,
      loading,
      validate,
      eventHandler,
      file,
      items,

      // validation
      validators: { required, emailValidator },
      icons: {
        mdiClose,
        mdiPencilOffOutline,
        mdiPencilOutline,
      },
    }
  },
}
</script>
